module.exports = __webpack_public_path__ + "static/media/LI3.e1f7e806.jpg";